import ChannelMixer from './ChannelMixer.js';


class ChannelMixerFactory {
    constructor() {
        this.channelMixers = [];
    }

    use(sequencerEngine) {
        if (this.channelMixers.length === 0 || !window.explore) {
            return new ChannelMixer(sequencerEngine);
        }

        let channelMixer = this.channelMixers.pop();
        channelMixer.sequencerEngine = sequencerEngine;
        if (channelMixer.mixEffects) {
            channelMixer.mixEffects.hp.cutoffFrequency = 0;
            channelMixer.mixEffects.lp.cutoffFrequency = 30000;
        }
        return channelMixer;
    }

    release(channelMixer) {
        this.channelMixers.push(
            channelMixer);
    }
}

export const channelMixerFactory = new ChannelMixerFactory();
